import React, {useState} from "react";
import s from './MyImageButton.module.css';

export function MyImageButton({borderColor, clickedAction, imgSrc, dWidth, hWidth, dTop, hTop}) {
	const [isHovered, setIsHovered] = useState(false);
  const [width, setWidth] = useState(dWidth);
  const [top, setTop] = useState(dTop && 50);
	
 const handleMouseEnter = () => {
    setIsHovered(true);
    setWidth(hWidth);
		if (hTop != null) {
			setTop(hTop);
		}
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    setWidth(dWidth);
		if (dTop != null) {
			setTop(dTop);
		}
  };


	
	return (<div className={s.buttonPic}  style={{borderColor}}
			onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}>
		<img style={{ width: `${width}px`, top: `${top}%`  }} className={s.absoluteImg} onClick={clickedAction} src={imgSrc}/>
	</div>)
}
